<template>
	<div id="services">
		Matthias<br />schreibt<br /><span v-html="service"></span>.
	</div>
</template>

<script>

// import Typewriter from 'typewriter-effect/dist/core';

export default {
	name: 'Services',
	block: 'services',
	data() {
		return {
			timer: 800,
			current: 0,
			service: 'Texte',
			services: [
				'Texte',
				'Marken&shy;storys',
				'Liebes&shy;gedichte',
				'Marken&shy;strategien',
				'Wording-Guidelines',
				'ins Stammbuch',
				'Kampagnen',
				'von der Seele',
				'Headlines',
				'Websites',
				'Newsletter',
				'Briefe',
				'Songs',
				'Unternehmens&shy;magazine',
				'Radio&shy;spots',
				'Geschichten',
				'Marken&shy;namen',
				'fehlerfrei',
				'Werbe&shy;konzepte',
				'schön',
				'Memoiren',
				'SMS',
				'Blogs',
				'Reportagen',
			],
		}
	},
	mounted() {
		setInterval(() => {
			// this.service = this.services[Math.floor(Math.random() * this.services.length)];
			this.service = this.services[this.current];
			this.current++;
			if (this.current === this.services.length) this.current = 0;
		}, this.timer);
	}
};
</script>

<style lang="scss">

@import "@/assets/styles/_base.scss";

.w-services {}

#services {
	max-width: 9em;
}

</style>
